import { useEffect } from "react";

/**
 * Tiny alternative to react-helmet — just sets document.title reactively.
 * Passing `null` leaves the current title untouched.
 */
export function useDocumentTitle(title) {
  useEffect(() => {
    if (!title) return;
    const prev = document.title;
    document.title = `${title} · Gulf Coast Work`;
    return () => {
      document.title = prev;
    };
  }, [title]);
}
